package com.ervasstudio.tracoemovimento.components.custumcomponents.layout

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.sections.HeaderCursos
import com.ervasstudio.tracoemovimento.model.Paginas
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.boxSizing
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

@Composable
fun AccordionItem(
    pagina: Paginas,
    content: @Composable () -> Unit,
    isExpanded: Boolean,
    onClick: (pagina: Paginas) -> Unit,
    backgroundColor: CSSColorValue = Colors.LightGray,
    currentPath: String,
    isMobile: Boolean,
) {
    // Desktop: expande em largura. Mobile: expande em altura.
    val collapsedSize = if (isMobile) 36.px else 2.percent
    val expandedSize = if (isMobile) 100.percent else 94.percent
    val itemSize = if (isExpanded) expandedSize else collapsedSize

    val baseModifier = Modifier
        .then(if (isMobile) Modifier.fillMaxWidth().height(itemSize)
              else Modifier.width(itemSize).fillMaxHeight())
        .overflow(overflowX = Overflow.Hidden, overflowY = Overflow.Auto)
        .classNames("no-scrollbar", "accordion-scroll-container")
        .backgroundColor(backgroundColor)
        .position(Position.Relative)
        .boxSizing(BoxSizing.BorderBox)
        .cursor(if (!isExpanded) Cursor.Pointer else Cursor.Default)
        .transition(
            Transition.of(
                if (isMobile) "height" else "width",
                0.5.s,
                AnimationTimingFunction.EaseInOut
            )
        )
        .onClick { if (!isExpanded) onClick(pagina) }

    if (isMobile) {
        Column(
            modifier = baseModifier,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            if (!isExpanded) {
                SpanText(
                    modifier = Modifier
                        .padding(topBottom = 8.px)
                        .fontFamily("Gotham")
                        .fontSize(13.px)
                        .fontWeight(FontWeight.Medium)
                        .lineHeight(1),
                    text = pagina.name
                    // sem rotação — texto lê-se normalmente na horizontal
                )
            } else {
                if (currentPath.startsWith("/cursos/")) {
                    Column(modifier = Modifier.fillMaxWidth()) {
                        HeaderCursos(
                            isMobile = isMobile
                        )
                        content()
                    }
                } else {
                    content()
                }
            }
        }
    } else {
        Row(
            modifier = baseModifier.padding(top = if (!isExpanded) 400.px else 0.px),
            horizontalArrangement = Arrangement.Center
        ) {
            if (!isExpanded) {
                SpanText(
                    modifier = Modifier
                        .margin(bottom = 0.px)
                        .fontFamily("Gotham")
                        .fontSize(20.px)
                        .fontWeight(FontWeight.Medium)
                        .textOverflow(TextOverflow.Ellipsis)
                        .lineHeight(1)
                        .styleModifier {
                            property("display", "-webkit-box")
                            property("-webkit-box-orient", "vertical")
                            property("transform", "rotate(270deg)")
                            property("transform-origin", "center center")
                        },
                    text = pagina.name
                )
            } else {
                if (currentPath.startsWith("/cursos/")) {
                    Column(modifier = Modifier.fillMaxWidth()) {
                        HeaderCursos(
                            isMobile = isMobile
                        )
                        content()
                    }
                } else {
                    content()
                }
            }
        }
    }
}